import { render, staticRenderFns } from "./Complex.vue?vue&type=template&id=66fe35ad&scoped=true&"
import script from "./Complex.vue?vue&type=script&lang=js&"
export * from "./Complex.vue?vue&type=script&lang=js&"
import style0 from "./Complex.vue?vue&type=style&index=0&id=66fe35ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fe35ad",
  null
  
)

export default component.exports